module.exports = __webpack_public_path__ + "img/activedirectory.a2b4e8bd.svg";